export default __webpack_public_path__ + "pgnv-assets/1f049095285708377bfd206fe72c17da.png";